function initCustomGallery() {
  const galleryWrappers = document.querySelectorAll('.zfc-gallery-wrapper');
  galleryWrappers.forEach((wrapper) => {
    if (wrapper.dataset.initialized === 'true') return;
    wrapper.dataset.initialized = 'true';

    const viewport = wrapper.querySelector('.zfc-gallery-viewport');
    const thumbnails = wrapper.querySelectorAll('.zfc-thumbnail-item');
    const dots = wrapper.querySelectorAll('.zfc-gallery-dot');
    const counterCurrent = wrapper.querySelector('.zfc-gallery-counter-current');

    if (!viewport) return;

    // Helper to update active states based on scroll position
    let isScrolling = false;
    function updateActiveStates() {
      if (viewport.clientWidth === 0) return;
      const index = Math.round(viewport.scrollLeft / viewport.clientWidth);

      // Sync thumbnails
      thumbnails.forEach((thumb, i) => {
        if (i === index) thumb.classList.add('active');
        else thumb.classList.remove('active');
      });

      // Sync dots
      dots.forEach((dot, i) => {
        if (i === index) dot.classList.add('active');
        else dot.classList.remove('active');
      });

      // Sync counter
      if (counterCurrent) {
        counterCurrent.textContent = index + 1;
      }
    }

    // Scroll listener with requestAnimationFrame debounce
    viewport.addEventListener('scroll', () => {
      if (!isScrolling) {
        window.requestAnimationFrame(() => {
          updateActiveStates();
          isScrolling = false;
        });
        isScrolling = true;
      }
    });

    // Handle thumbnail clicks
    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = parseInt(thumb.dataset.targetSlide);
        if (isNaN(index)) return;
        viewport.scrollTo({
          left: index * viewport.clientWidth,
          behavior: 'smooth'
        });
      });
    });

    // Handle dot clicks
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.targetSlide);
        if (isNaN(index)) return;
        viewport.scrollTo({
          left: index * viewport.clientWidth,
          behavior: 'smooth'
        });
      });
    });

    // Initial state check
    updateActiveStates();
  });
}

// Initial initialization
document.addEventListener('DOMContentLoaded', initCustomGallery);

// Watch for DOM changes (e.g. section refreshes or customized sections)
const galleryObserver = new MutationObserver(() => {
  initCustomGallery();
});
galleryObserver.observe(document.body, { childList: true, subtree: true });

// Listen to Dawn variant switch event to scroll to featured media
document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      // Re-init in case DOM replaced
      initCustomGallery();

      const sectionId = event.data.sectionId;
      const variant = event.data.variant;
      if (!variant || !variant.featured_media) return;

      const mediaId = variant.featured_media.id;
      const gallery = document.querySelector(`#MediaGallery-${sectionId}`);
      if (gallery) {
        const viewport = gallery.querySelector('.zfc-gallery-viewport');
        const slide = gallery.querySelector(`.zfc-gallery-slide[data-media-id="${mediaId}"]`);
        if (viewport && slide) {
          const index = parseInt(slide.dataset.index);
          if (!isNaN(index)) {
            viewport.scrollTo({
              left: index * viewport.clientWidth,
              behavior: 'smooth'
            });
          }
        }
      }
    });
  }
});